export default function (formatMessage: Function) {
  return {
    terminateReasonOptions: [
      {
        value: "won",
        label: formatMessage({
          id: "terminate_reason_won",
          defaultMessage: "Realizzato con almenouna soluzione Kerakoll",
        }),
      },
      {
        value: "lost",
        label: formatMessage({
          id: "terminate_reason_lost",
          defaultMessage: "Realizzato con altre soluzioni",
        }),
      },
      {
        value: "incomplete",
        label: formatMessage({
          id: "terminate_reason_incomplete",
          defaultMessage: "Altro",
        }),
      },
    ],
  };
}
